import React, { memo, useCallback } from 'react';
import { Keyboard, TouchableOpacity, View } from 'react-native';
import Text from 'design-system/Text';
import IconTooltip from 'design-system/icons/IconTooltip';
import BlurAmountView from 'design-system/BlurAmountView';
import { hitSlopS, IconArrow, rem, Spacer } from 'design-system';
import useStyles from 'hooks/useStyles';
import Modal from 'utils/packages/Modal';
import { useAppSelector } from 'store/hooks';
import { formatAmount } from 'utils/formatting';
import createStyleSheets from 'utils/createStyleSheets';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
const TransferPotRow = ({ name, Icon, amount, disabled = false, onPress, isPickerModalOpen, }) => {
    const styles = useStyles(styleSet);
    const scrambled = useAppSelector((store) => store.utils.scrambled);
    const onInfoButtonPress = useCallback(() => {
        Keyboard.dismiss();
        Modal.showConfirmation({
            title: 'Available',
            subtitle: 'These are the funds available right now in the Emma Pot. It may be lower than your total balance if you have money pending from recent transfers.',
            confirmButtonTitle: 'Okay',
        });
    }, []);
    return (<TouchableBounceCard onDark noMarginTop noMarginBottom onPress={onPress} disabled={disabled} style={styles.cardBtn}>
      <View style={styles.row}>
        <View style={styles.iconContainer}>{Icon}</View>
        <Spacer w={16}/>
        <View style={styles.flex}>
          <Text Text-16 numberOfLines={1}>
            {name}
          </Text>
          {!!amount && (<View style={styles.row}>
              <Text TextThin-14 Secondary>
                Available{' '}
              </Text>
              <BlurAmountView enabled={scrambled}>
                <Text NumbersThin-14 Secondary>
                  {formatAmount(amount.value, amount.currency, 2)}
                </Text>
              </BlurAmountView>
              <Spacer w={4}/>
              <TouchableOpacity onPress={onInfoButtonPress} hitSlop={hitSlopS}>
                <IconTooltip colorKey="secondary" width={16} height={16}/>
              </TouchableOpacity>
            </View>)}
        </View>
        {!disabled && (<View style={styles.arrow}>
            <IconArrow direction={isPickerModalOpen ? 'up' : 'down'}/>
          </View>)}
      </View>
    </TouchableBounceCard>);
};
const styleSet = createStyleSheets((colors) => ({
    arrow: {
        width: rem(10),
        marginLeft: rem(16),
    },
    cardBtn: {
        paddingVertical: rem(24),
        paddingHorizontal: rem(16),
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    iconContainer: {
        width: rem(44),
        height: rem(44),
        alignItems: 'center',
        borderRadius: rem(22),
        justifyContent: 'center',
        backgroundColor: colors.background.dark,
    },
    flex: {
        flex: 1,
    },
}));
export default memo(TransferPotRow);
